/**
 * Tanzanian shilling.
 */
export var TZS = {
  code: 'TZS',
  base: 10,
  exponent: 2
};